var _path, _path2, _circle, _path3, _rect, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPermission3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 145,
    viewBox: "0 0 136 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.496 69.3737C110.496 73.5185 107.137 76.8779 102.992 76.8779H32.9527C28.8079 76.8779 25.4485 73.5185 25.4485 69.3737V34.3542C25.4485 30.2094 28.8079 26.85 32.9527 26.85H102.992C107.137 26.85 110.496 30.2094 110.496 34.3542V69.3737Z",
    fill: "url(#paint0_linear_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.499 116.9H95.4931C94.1124 116.9 92.9917 115.78 92.9917 114.399V106.895H42.9527V114.399C42.9527 115.78 41.8321 116.9 40.4513 116.9H20.4457C19.065 116.9 17.9443 115.78 17.9443 114.399V94.3877H118V114.399C118 115.78 116.879 116.9 115.499 116.9Z",
    fill: "url(#paint1_linear_3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9033,
    cy: 62.6595,
    r: 15.4472,
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 94.3876H17.9443V92.2039C17.9443 68.208 25.3385 61.8695 66.8941 61.8695C106.536 61.8695 118 66.9799 118 92.2039V94.3876Z",
    fill: "url(#paint2_linear_3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63,
    width: 118,
    height: 18,
    rx: 9,
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7426 6.12231H18C11.3726 6.12231 6 11.4949 6 18.1223V22.8649",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 22.8649L130 18.1223C130 11.4949 124.627 6.12231 118 6.12231L113.257 6.12231",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 138.494L118 138.494C124.627 138.494 130 133.121 130 126.494L130 121.751",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 121.751L6 126.494C6 133.121 11.3726 138.494 18 138.494L22.7426 138.494",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3",
    x1: 67.9722,
    y1: 26.85,
    x2: 67.9722,
    y2: 76.8779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A14A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3",
    x1: 117.649,
    y1: 94.256,
    x2: 17.9443,
    y2: 94.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A14A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3",
    x1: 17.9443,
    y1: 94.256,
    x2: 117.649,
    y2: 94.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C94C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2884C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission3);
export default __webpack_public_path__ + "static/media/camera_permission_3.21653552.svg";
export { ForwardRef as ReactComponent };